import React, { createContext, useContext, useState } from 'react'

interface GeralFilterContextType {
  year: number
  month: number
  semana: string
  distributorId: string | null
  startDate: Date | null
  endDate: Date | null
  setYear: (y: number) => void
  setMonth: (m: number) => void
  setSemana: (s: string) => void
  setDistributor: (id: string | null) => void
  setStartDate: (date: Date | null) => void
  setEndDate: (date: Date | null) => void
  gestor: string
  setGestor: (g: string) => void
  operacao: string
  setOperacao: (o: string) => void
  marca: string
  setMarca: (m: string) => void
  categoria: string
  setCategoria: (c: string) => void
  cliente: string
  setCliente: (c: string) => void
  uf: string
  setUf: (c: string) => void
}

const GeralClienteFilterContext = createContext<GeralFilterContextType | undefined>(undefined)

export const GeralClienteFilterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const now = new Date()

  const [year, setYear] = useState<number>(now.getFullYear())
  const [month, setMonth] = useState<number>(now.getMonth())
  const [semana, setSemana] = useState<string>('todas')
  const [distributorId, setDistributor] = useState<string | null>(null)
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [marca, setMarca] = useState<string>('')
  const [gestor, setGestor] = useState<string>('')
  const [operacao, setOperacao] = useState<string>('')
  const [categoria, setCategoria] = useState<string>('')
  const [cliente, setCliente] = useState<string>('')
  const [uf, setUf] = useState<string>('')

  return (
    <GeralClienteFilterContext.Provider
      value={{
        year,
        month,
        semana,
        distributorId,
        startDate,
        endDate,
        setYear,
        setMonth,
        setSemana,
        setDistributor,
        setStartDate,
        setEndDate,
        gestor,
        setGestor,
        operacao,
        setOperacao,
        marca,
        setMarca,
        categoria,
        setCategoria,
        cliente,
        setCliente,
        setUf,
        uf,
      }}
    >
      {children}
    </GeralClienteFilterContext.Provider>
  )
}

export const useGeralClienteFilter = () => {
  const context = useContext(GeralClienteFilterContext)
  if (!context)
    throw new Error('useGeralClienteFilter deve ser usado dentro de GeralFilterProvider')
  return context
}
